import CalculatorStore from "../../Configs/Store/calculator"

const ageValidation = (value, min, max) => {
  var regExp = /[a-zA-Z]/g
  var flag = regExp.test(value)
  var errorMsg = ""

  if(!flag){
    if(value >= min && value <= max){
      return {
        valid: true,
        age: value,
        errorMsg: errorMsg
      }
    } else {
      return {
        valid: false,
        errorMsg: `Age should be between ${min} to ${max} years`
      }
    }
  } else {
    return {
      valid: false,
      errorMsg: errorMsg
    }
  }
}

const amountValidation = (value, min, max) => {
  var regExp = /^[0-9]*$/
  var flag = regExp.test(value)
  var errorMsg = "Please fill the required fields"
  var SrcValue = ''
  if(CalculatorStore.screenNo  === "Scr5") { 
    SrcValue = "Savings"
  } else {
    SrcValue = "Expense"
  }
  
  if(!flag){
    return {
      valid: false,
      errorMsg: errorMsg
    }
  } else {
    if(value >= min && value <= max){
      return {
        valid: true,
        age: value,
        errorMsg: ''
      }
    } else {
      if(value === 0){
        return {
          valid: false,
          errorMsg: errorMsg
        }
      } else {
        return {
          valid: false,
          errorMsg: `Total ${SrcValue} should be less than 100 Crores`
        }
      }
    }
  }
}

const getKeyByValueOfJson = (object, value) => {
  return Object.keys(object).find(key => object[key] === value);
}

const getValueByKeyOfJson = (object, keyVal) => {
    for (var key in object) {
      if(key === keyVal)
        return object[key]
    }
    return ""
}

export { ageValidation, amountValidation, getKeyByValueOfJson, getValueByKeyOfJson }